import React from 'react';
import './LegalPage.css';
import Pricing from "../components/Pricing";

const Organizacion = () => (
    <div className="legal-page">
        <h1>Organización y Automatización de CRM</h1>
        <h2>"El motor invisible que impulsa tu crecimiento comercial"</h2>
        <p>
            El verdadero activo de una empresa es su información. Nos enfocamos en transformar tus sistemas internos
            para que dejen de ser simples bases de datos y se conviertan en herramientas proactivas.
            Automatizamos el ciclo de vida de tu cliente para asegurar que ningún lead se enfríe y maximizar la
            recaptación.
        </p>

        <h3>¿Cómo optimizamos tu gestión interna?</h3>
        <ul>
            <li><strong>Gestión del Ciclo de Vida:</strong> Seguimiento automático desde el primer contacto hasta la
                post-venta.
            </li>
            <li><strong>Estrategias de Recaptación:</strong> Detecta clientes inactivos y lanza campañas personalizadas
                para reactivarlos automáticamente.
            </li>
            <li><strong>Sincronización Total:</strong> Conecta tu CRM con tus herramientas de marketing, facturación y
                soporte.
            </li>
            <li><strong>Limpieza de Datos:</strong> Mantenimiento automático de tu base de datos para asegurar
                información fiable y útil.
            </li>
        </ul>

        <h3>Tecnologías y CRMs compatibles:</h3>
        <p>HubSpot, Salesforce, Zoho, Pipedrive, Make (Integromat), Zapier, Airtable y soluciones a medida.</p>

        <h3>Ejemplo real:</h3>
        <p>
            Un cliente potencial pide información pero no compra. El sistema lo detecta, espera 3 días y le envía un
            caso de éxito relevante.
            Si el cliente muestra interés, el CRM alerta automáticamente al equipo comercial y agenda una llamada
            prioritaria, aumentando la tasa de conversión sin esfuerzo manual.
        </p>

        <Pricing/>
    </div>
);
export default Organizacion;
